const rate = {
  path: 'rate',
  component: resolve => require(['../../../../../../pages/admin/reviewed/alipay/rate'], resolve),
  meta: {isRate: true}
}

export default rate
